"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegendMenu = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.LegendMenu = function (_a) {
    var color = _a.color, className = _a.className, width = _a.width, height = _a.height;
    return (react_1.default.createElement("svg", { className: className, width: width !== null && width !== void 0 ? width : 9, height: height !== null && height !== void 0 ? height : 10, viewBox: "0 0 11 10", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", { id: "Legend", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", { id: "LegendIcoContent", transform: "translate(-5.500000, -6.000000)", fill: color !== null && color !== void 0 ? color : "#6D7680" },
                react_1.default.createElement("path", { d: "M7.5,14 L7.5,16 L5.5,16 L5.5,14 L7.5,14 Z M16.5,14 L16.5,16 L9.5,16 L9.5,14 L16.5,14 Z M7.5,10 L7.5,12 L5.5,12 L5.5,10 L7.5,10 Z M16.5,10 L16.5,12 L9.5,12 L9.5,10 L16.5,10 Z M7.5,6 L7.5,8 L5.5,8 L5.5,6 L7.5,6 Z M16.5,6 L16.5,8 L9.5,8 L9.5,6 L16.5,6 Z", id: "Combined-Shape" })))));
};
//# sourceMappingURL=LegendMenu.js.map